import { SlideSizeType } from './slide-size.interface';

/**
 * 根据传入的幻灯片尺寸大小，获取对应的size类型，比如返回16:9 ， 4:3类型
 * @param slideWidth
 * @param slideHeight
 */
export function checkSlideSizeType(slideWidth: number, slideHeight: number) {
    const deviation = 0.17;
    const floatVal = slideWidth / slideHeight;

    const f16To9 = 16 / 9;
    const f4To3 = 4 / 3;

    let type: SlideSizeType = SlideSizeType.SLIDE_SIZE_CUSTOM;
    if (Math.abs(floatVal - f16To9) < deviation) {
        type = SlideSizeType.SLIDE_SIZE_16_9;
    } else if (Math.abs(floatVal - f4To3) < deviation) {
        type = SlideSizeType.SLIDE_SIZE_4_3;
    }

    return type;
}
